<template>
    <v-card class="kim-card pa-4">

        <template>

            <v-card-text class="pa-2">

                <v-layout wrap>

                    <v-flex v-if="!isReadOnly" xs12 md6 text-left pa-3>

                        <v-layout wrap>
                          <v-flex xs12 md10>

                            <div class="body-2">

                              Agregar Exámen(es)

                              <v-tooltip top>
                                <template v-slot:activator="{on}">
                                  <v-icon v-on="on" color="primary" @click="goToSettings" size="16">fa-cog</v-icon>
                                </template>
                                Configurar
                              </v-tooltip>
                            </div>

                            <template>
                              <physical-exam-picker
                                  :event-id="eventId"
                                  @attach="onExamAttach"
                                  :locked="lockedExams"
                              />
                            </template>
                          </v-flex>
                        </v-layout>
                      <v-divider class="my-2"></v-divider>


                    </v-flex>

                    <v-flex :class="['xs12', {'md6': !isReadOnly}, 'mb-4', 'text-left', 'pa-3']" :style="{'border-left': !isReadOnly ? '1px solid #ccc' : 'none'}">

                        <div class="body-2">Exámenes agregados</div>
                        <v-divider class="my-2"></v-divider>

                        <div class="caption mt-4 text-center" v-if="!exams || exams.length === 0">
                            No se han agregado exámenes
                        </div>

                        <div v-else class="text-center">
                            <client-physical-exams
                                :event-id="eventId"
                                :exams="exams"
                                :readonly="isReadOnly"
                                @detach="onDetach"
                                @update="onUpdate"
                            />
                        </div>

                    </v-flex>

                </v-layout>

            </v-card-text>

        </template>

    </v-card>

</template>

<script>

    import ClientPhysicalExams from './ClientPhysicalExams'
    import PhysicalExamPicker from './PhysicalExamPicker'

    export default{
        components: {ClientPhysicalExams, PhysicalExamPicker},
        props: ['exams', 'readonly', 'eventId'],
        methods:{
          goToSettings(){
            const vm = this
            vm.$router.push({
              name: 'panel.provider.settings',
              query: {view: 'ClinicalRecord'}
            })
          },
            onDetach(exam){
                this.$emit('detach', exam)
            },
            onUpdate(exam){
                this.$emit('update', exam)
            },
            onExamAttach(exam){
                this.$emit('attach', exam)
            }
        },
        computed: {
            isReadOnly(){
                return this.readonly !== undefined && this.readonly !== false
            },
            lockedExams(){
                var vm = this
                return vm.exams.map(exam => exam.id)
            }
        }

    }
</script>
